import Application from "../Application";
import Area, { IArea } from "./Area";
import { IRouter } from "../runtime/Router";
import ShowLoginInteractor from "../interactor/authentication/ShowLoginInteractor";
import LoginPage from "../ui/pages/authentication/LoginPage";
import LogoutPage from "../ui/pages/authentication/LogoutPage";
import LogoutInteractor from "../interactor/authentication/LogoutInteractor";
import ShowPasswordResetInteractor from "../interactor/authentication/ShowPasswordResetInteractor";
import PasswordResetPage from "../ui/pages/authentication/PasswordResetPage";
import PasswordResetConfirmationPage from "../ui/pages/authentication/PasswordResetConfirmationPage";
import ShowPasswordResetConfirmationInteractor from "../interactor/authentication/ShowPasswordResetConfirmationInteractor";

export default class AuthenticationArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes(
      {
        path: "/device-login",
        page: this.createPage({
          Page: LoginPage,
          action: this.showLoginPage.bind(this)
        })
      },
      {
        path: "/device-logout",
        page: this.createPage({
          Page: LogoutPage,
          action: this.doLogout.bind(this)
        })
      },
      {
        path: "/reset-password",
        page: this.createPage({
          Page: PasswordResetPage,
          action: this.showPasswordResetPage.bind(this)
        })
      },
      {
        path: "/confirm-password",
        page: this.createPage({
          Page: PasswordResetConfirmationPage,
          action: this.showPasswordResetConfirmationPage.bind(this)
        })
      }
    );
  }

  public showLoginPage(params: any) {
    return this.application.container
      .resolve<ShowLoginInteractor>("showLogin")
      .execute(params.lang);
  }

  public doLogout() {
    return this.application.container
      .resolve<LogoutInteractor>("logout")
      .execute();
  }

  public showPasswordResetPage() {
    return this.application.container
      .resolve<ShowPasswordResetInteractor>("showPasswordReset")
      .execute();
  }
  public showPasswordResetConfirmationPage(params: any) {
    return this.application.container
      .resolve<ShowPasswordResetConfirmationInteractor>(
        "showPasswordResetConfirmation"
      )
      .execute(params.userId, params.token, params.language);
  }
}
